// Imports
import rateioInput from './rateioInput';

// Requires
const Lang                          = require('lang');
const GlobalAlerts                  = require('./GlobalAlerts');
const Filters                       = require('../classes/Filters.js');
const template                      = require('lodash/template')
const ConversaoCambio               = require('./ConversaoCambio');
const templateJustifyDontConciliate = template(require('../templates/justificativa-nao-conciliar.html'))

// Routes
const routeExpenseDetails     = 'app.despesas.show.conciliacao';
const routeStoreExpense       = 'app.despesas.store';
const routeConciliarItem      = 'app.conciliacoes.conciliar-item';
const routeGetCardExpense     = 'app.despesas.card-despesa-show';
const routeFilterExpenses     = 'app.conciliacoes.filtra-despesas';
const routeDontConciliateItem = 'app.conciliacoes.nao-conciliar-item';

// Selectors
const dataSelectorCardExpense                 = '[data-draggable]';
const classSelectorInvoiceItem                = '.invoice-item';
const classSelectorBadgeStatus                = '.badge';
const dataSelectorQueueExpenses               = '[data-droppable-scope="queue"]';
const dataSelectorGapCardExpense              = '[data-droppable-expense]';
const dataAttributeCardExpenseId              = 'data-draggable-expense-id';
const idSelectorFormCreateExpense             = '#form-despesa';
const dataSelectorInvoiceItemDiff             = '[data-droppable-invoice-item-diff]';
const idSelectorContainerInvoices             = '#container-invoices';
const classSlectorInvoiceItemComment          = '.invoice-item__comment';
const dataSelectorButtonDisconcillate         = '[data-button-disconcillate]';
const dataSelectorButtonExpandFilters         = '[data-clean-form-search]';
const dataSelectorButtonDontConciliate        = '[data-button-dont-conciliate]';
const dataSelectorButtonExpenseDetails        = '[data-draggable-expense-show-details]';
const dataSelectorButtonConfirmConciliation   = '[data-button-confirm-conciliation]';
const dataSelectorCheckConfirmeConciliation   = '[data-check-confirm-conciliation]';
const dataSelectorConfirmConciliationsChecked = '[data-button-confirm-conciliations-checked]';

// Classes
const classInvoiceItem           = 'invoice-item';
const classDroppableMatch        = 'activate';
const classCardExpenseOpacity    = 'expense-card--opacity';
const classCardExpenseDragging   = 'expense-card--dragging';
const classInvoiceItemDifference = 'invoice-item__difference';


// Constants
const translateStatusConciliacao = {
  aberto: 'open',
  conciliado: 'conciled',
  possivelmente_conciliado: 'possibly_conciled',
  nao_conciliado: 'not_concilided',
  encerrado: 'closed',
  politica_violada: 'policy_violated',
};

// Data atributes
const attributeHasExpense = 'data-droppable-has-expense';

function ConciliacoesDroppable() {
  nifty.body.overlay({
    fixed: true
  });

  settings();
}

/**
 * Configura os listeners e os elementos que
 * devem recebê-los
 */
function settings() {
  const $cardExpenses                      = $(dataSelectorCardExpense);
  const $expenseGaps                       = $(dataSelectorGapCardExpense);
  const $invoiceItems                      = $(classSelectorInvoiceItem);
  const $formCreateExpense                 = $(idSelectorFormCreateExpense);
  const $buttonsDisconcillate              = $(dataSelectorButtonDisconcillate);
  const $buttonsDontConciliate             = $(dataSelectorButtonDontConciliate);
  const $buttonShowExpenseDetails          = $(dataSelectorButtonExpenseDetails);
  const $buttonConfirmConciliation         = $(dataSelectorButtonConfirmConciliation);
  const $buttonConfirmConciliationsChecked = $(dataSelectorConfirmConciliationsChecked);

  if ($cardExpenses.length) {
    initializeDraggableCardExpense($cardExpenses);
  }

  if ($expenseGaps.length) {
    initializeDroppableCardExpenseGap($expenseGaps);
  }

  if ($buttonsDontConciliate.length) {
    $buttonsDontConciliate.on('click', handlerClickDontConciliation);
  }

  if ($buttonsDisconcillate.length) {
    $buttonsDisconcillate.on('click', handlerClickDisconcillate);
  }

  if ($buttonShowExpenseDetails.length) {
    $buttonShowExpenseDetails.on('click', handlerClickShowExpenseDetails);
  }

  if ($formCreateExpense.length) {
    $formCreateExpense.on('submit', handlerSubmitFormCreateExpense);
  }

  if ($buttonConfirmConciliation.length) {
    $buttonConfirmConciliation.on('click', handlerClickConfirmConciliation);
  }

  if ($invoiceItems.length) {
    $invoiceItems.on('click', handlerClickInvoiceItem);
  }

  if ($buttonConfirmConciliationsChecked !== null) {
    $buttonConfirmConciliationsChecked.on('click', handlerClickButtonConfirmConciliationsChecked)
  }

  initializeScrollContainerInvoices();
  initializeExpensesFilters();
}

/**
 * Incializando os cards de despesas como um elemento
 * draggable e aplicando a estes elementos  os eventos
 * de start e stop
 *
 * @param {array<Element>} $cardExpenses
 */
function initializeDraggableCardExpense($cardExpenses) {
  $cardExpenses.draggable({
    revert: 'invalid',
    helper: 'clone',
    refreshPositions: true,
    revertDuration: 300,
    zIndex: 999,
    start: function (event, ui) {
      // habilitando o scroll da div com itens e fatura
      window.enableScrollInvoices = true;
      toogleClassesCardDragging(event.target, ui.helper[0]);
    },
    stop: function (event, ui) {
      // desabilitando o scroll da div com itens e fatura
      window.enableScrollInvoices = false;
      toogleClassesCardDragging(event.target, ui.helper[0]);
    }
  });
}

/**
 * Inicialando os gaps e a fila como um elemento droppable
 * onde os cards de despesas podem ser colocados quando
 * estiverem sendo arrastados e adicionando o evento de drop
 * ao elemento
 *
 * @param {array<Element>} $expenseGaps
 */
function initializeDroppableCardExpenseGap($expenseGaps) {
  $expenseGaps.droppable({
    tolerance: 'intersect',
    classes: {
      'ui-dropppable-hover': classDroppableMatch
    },
    drop: function(event, ui) {
      const gapHolder       = event.target;
      const cardIdentify    = ui.draggable.attr('data-draggable-expense-id');
      const cardExpense = document.querySelector(`[${dataAttributeCardExpenseId}="${cardIdentify}"]`);

      applyCardMovement(gapHolder, cardExpense);
    }
  });
}


/**
 * Clique do botão de não conciliar item fatura
 *
 * Enviando uma request ajax para o servidor para salvar a informação
 * de que que o usuário não deseja conciliar este item de fatura, e
 * em seguida alterando o status e as mensagens do item de fatura
 * exibido na tela
 *
 * @param {Event} event
 */
function handlerClickDontConciliation(event) {
  const gapHolder = event.target.closest(dataSelectorGapCardExpense);
  const holderMessage = gapHolder.closest(classSelectorInvoiceItem).querySelector(classSlectorInvoiceItemComment);
  const paragraphMessage = holderMessage.querySelector('p');

  const data = {
    idFaturaItem: gapHolder.dataset.droppableInvoiceItemId,
    justificativa: ''
  };

  // Dialog para confirmar se deseja não conciliar o item,
  // e coletar a justificatava pra não realizar a conciliação
  bootbox.dialog({
    title: Lang.get('js/src/functions/ConciliacoesDroppable.title_dialog_dont_conciliate'),
    message: templateJustifyDontConciliate,
    buttons: {
      cancel: {
        label: Lang.get('js/src/functions/ConciliacoesDroppable.cancel'),
        className: 'btn-danger'
      },
      confirm: {
        label: Lang.get('js/src/functions/ConciliacoesDroppable.save'),
        className: 'btn-success',
        callback: function() {
          data.justificativa = $(this).find('#justificativa').val();

          // Validando o campo de justificativa, ele é obrigatório
          if (!data.justificativa.length) {
            showError(Lang.get('js/src/functions/ConciliacoesDroppable.error_valid_justify'));
            return false;
          }

          postRequest(data, routeDontConciliateItem)
            .done(function (response) {
              const langJustify = Lang.get('js/src/functions/ConciliacoesDroppable.justify');

              // Atualizando o status do item de fatura na tela
              changeStatusInvoiceItem(response.data, gapHolder);

              // Exibindo a justificativa de não conciliação
              paragraphMessage.innerHTML = `<strong>${langJustify}:</strong> ${data.justificativa}`;

              // Tratando casos antigos de itens que não tinham
              // justificativas
              if (holderMessage.classList.contains('hidden')) {
                holderMessage.classList.remove('hidden');
              }
            })
            .fail(function (error) {
              // Alterando o status dos itens que estavam sendo manipulados
              changeStatusInvoiceItem(error.responseJSON.data, gapHolder);
              // Exibindo toast com mensagem de erro padrão
              showError(error.responseJSON.message);
            });
        }
      }
    }
  });
}

/**
 * Clique do botão de desconciliar um item de fatura
 *
 * Enviando uma request ajax para os servidor que irá retirar
 * o item de despesa do item de fatura, em seguida alterando
 * o conteúdo de informação da diferença de valores entre a
 * despesa e o item de fatura, e alterando o statuso do item
 * de fatura
 *
 * @param {Event} event
 */
function handlerClickDisconcillate(event) {
  const gapHolder = event.target.closest(dataSelectorGapCardExpense);
  const data = getDataToSendConciliation({}, gapHolder);

  postRequest(data, routeConciliarItem)
    .done(function (response) {

      // Setando no gap que ele não possui mais uma despesa, já que este
      // botao desfaz a conciliação
      gapHolder.setAttribute(attributeHasExpense, false);

      // Alterando a aprensentação da difença de valor entre o item do card
      // e o item de fatura
      showDiffBetweenInvoiceItemAndExpenseCard(response.data, gapHolder);
      // Atualizando o status do item de fatura na tela
      changeStatusInvoiceItem(response.data, gapHolder);

      // Adicionando o card que estava no gap, no topo da fila de despesas
      // a serem conciliadas
      const queueExpensesHolder = document.querySelector(dataSelectorQueueExpenses);
      const firstCardExpense = queueExpensesHolder.querySelector(dataSelectorCardExpense);
      const cardExpenseInGap = gapHolder.querySelector(dataSelectorCardExpense);
      queueExpensesHolder.insertBefore(cardExpenseInGap, firstCardExpense);
    })
    .fail(function (error) {
      // Alterando o status dos itens que estavam sendo manipulados
      changeStatusInvoiceItem(error.responseJSON.data, gapHolder);
      // Exibindo toast com mensagem de erro padrão
      showError(error.responseJSON.message);
    })
}

/**
 * Clique do botão de visualização da despesa
 *
 * Enviando uma request ao servidor para obter o conteúdo
 * de informação relacioanda a despesa que o usuário clicou
 * no botão, em seguida um modal será exibido com as
 * informaçoes obtidas
 *
 * @param {Event} event
 */
function handlerClickShowExpenseDetails(event) {
  const idDespesaItem = event.target.closest('.expense-card').dataset.draggableExpenseId;
  const params = {
    despesa: idDespesaItem
  };

  getRequest(params, routeExpenseDetails)
    .done(function (response) {
      const contentModal = document.querySelector('#despesa-detalhes-content');
      contentModal.innerHTML = response;
    })
    .fail(function (error) {
      // Exibindo toast com mensagem de erro padrão
      showError();
    });
}

/**
 *
 *
 * @param {Event} event
 */
function handlerSubmitFormCreateExpense(event) {
  event.preventDefault();
  event.stopImmediatePropagation();

  const $formDespesa = $(event.target);
  const $modalDespesa = $formDespesa.closest('.modal');

  if (!$formDespesa.valid()) {
    return;
  }

  // Habilitado o campo de forma de pagamento,
  // este campo está bloqueado quando conciliação
  // está ativa
  $($formDespesa)
    .find('#reembolsavelDespesa')
    .attr('disabled', false);

  const data = new FormData($formDespesa[0]);
  postRequest(data, routeStoreExpense, true)
    .done(function (response) {
      GlobalAlerts.createAndShow({
        type: 'success',
        title: Lang.get('js/common/words.success'),
        message: response.message
      });

      // Criando o card da despesa na fila
      createCardExpense(response.data.id);

      // No caso de sucesso fecha o modal e desaplica
      // o overlay do form
      $modalDespesa.modal('hide');
      $formDespesa.overlay('hide');
    })
    .fail(function (error) {
      showError();
    })
    .always(function () {
      $formDespesa.overlay('hide');

      // Desabilitando novamente o checkbox e reembolsável
      $($formDespesa)
        .find('#reembolsavelDespesa')
        .attr('disabled', true);
    });

  return false;
}

/**
 * Clique do botão de confirmar conciliação
 *
 * Enviando uma request ao servidor para salvar a
 * conciliação do item de despesa com o item de fatura
 *
 * @param {Event} event
 */
function handlerClickConfirmConciliation(event) {
  const gapHolder = event.target.closest(dataSelectorGapCardExpense);
  const cardExpense = event.target.closest(dataSelectorCardExpense);
  const data = getDataToSendConciliation({}, gapHolder, cardExpense);

  postRequest(data, routeConciliarItem)
    .done(function (response) {
      // Exibindo as informações de diferença entre o card de despesa o item de fatura
      showDiffBetweenInvoiceItemAndExpenseCard(response.data, gapHolder);
      // Aplicando a alteração de status os itens envolvidos
      changeStatusInvoiceItem(response.data, gapHolder);
      //Abrindo modal de violações de política se existem
      if (!!response.data.quebraPolitica) {
        showItemsOutOfPolicy();
      }
    })
    .fail(function (error) {
      // Exibindo toast com mensagem de erro padrão
      showError();
    });
}

/**
 * Click no item de fatura
 *
 * Ao clicar no item de fatura será realizada a interação com
 * o checkbox de confirmar as conciliações sugeridas pelo sistema,
 * se o check estiver marcado, ele será desmarcado no click do item
 * de fatura, o oposto acontece se ele estivar desmarcado, passando
 * a ser marcado
 *
 * @param {Event} event
 */
function handlerClickInvoiceItem(event) {
  const invoiceItem = event.target;
  const checkBoxConfirmConciliation = invoiceItem.querySelector(dataSelectorCheckConfirmeConciliation);

  if (checkBoxConfirmConciliation === null) {
    return;
  }

  checkBoxConfirmConciliation.closest('label').classList.toggle('active');

  if (checkBoxConfirmConciliation.checked) {
    checkBoxConfirmConciliation.removeAttribute('checked');
    return;
  }

  checkBoxConfirmConciliation.setAttribute('checked', 'checked');
}

/**
 * Click do botão de confirmar as conciliações marcadas
 *
 * Ao clicar no botão que confirma múltiplas conciliações,
 * todos itens que estiverem com o checkbox marcado, irão compor
 * o objeto que será enviado para o servidor em uma request para
 * salvar todas estas conciliações, feito isso, o retorno do
 * servidor será percorrido para alterar o status dos itens
 */
function handlerClickButtonConfirmConciliationsChecked(event) {
  const buttonConfirmAll = event.target;
  const checkBoxesConfirmConciliation = document.querySelectorAll(dataSelectorCheckConfirmeConciliation);

  buttonConfirmAll.disabled = true;

  // Obtendo os dados das conciliações que serão enviadas para o servidor
  const data = {};
  checkBoxesConfirmConciliation.forEach((currentCheckbox) => {
    if (currentCheckbox.checked === false) {
      return;
    }
    const invoiceItem     = currentCheckbox.closest(classSelectorInvoiceItem);
    const cardExpense     = invoiceItem.querySelector(dataSelectorCardExpense);
    const holderDroppable = invoiceItem.querySelector(dataSelectorGapCardExpense);

    getDataToSendConciliation(data, holderDroppable, cardExpense);
  });

  bootbox.confirm({
    title: Lang.get('js/src/functions/ConciliacoesDroppable.title_modal_confirm'),
    message: Lang.get('js/src/functions/ConciliacoesDroppable.message_modal_confirm'),
    buttons: {
      confirm: {
        label: Lang.get('js/common/words.yes'),
        className: 'btn-success',
      },
      cancel: {
        label: Lang.get('js/common/words.cancel'),
        className: 'btn-danger'
      }
    },
    callback: function (result) {
      if (!result) {
        buttonConfirmAll.disabled = false;
        return;
      }

      postRequest(data, routeConciliarItem)
        .done(function(response) {
          // Percorrendo o objeto de resposta para a chamada
          // da função de alteração de status do item de fatura
          Object.keys(response.data).map(function(key) {
            if (key !== 'quebraPolitica') {
              const gapHolder = document.querySelector(`[data-droppable-invoice-item-id="${key}"]`);
              // Aplicando a alteração de status os itens envolvidos
              changeStatusInvoiceItem(response.data, gapHolder);
              //Abrindo modal de violações de política se existem
              if (!!response.data.quebraPolitica) {
                showItemsOutOfPolicy();
              }
            }
          });
        })
        .fail(function(error) {
          // Exibindo toast com mensagem de erro padrão
          showError();
        })
        .always(() => buttonConfirmAll.disabled = false);
    }
  });
}

/**
 * Inicialiazando o evento de mousemove no window, para fazer
 * o scroll do conteúdo de itens da fatura quando um car estiver
 * sendo arrastado
 */
function initializeScrollContainerInvoices() {
  const $container = $(idSelectorContainerInvoices);
  let scrollSize = 0;

  // Se o window não tiver setado a propriedade
  // que livera o scroll, seta ela com false por hora
  if (window.enableScrollInvoices === undefined) {
    window.enableScrollInvoices = false;
  }

  $(window).on('mousemove', function (e) {
    const tamanhoTela = parseInt($(window).height());
    const mouseY = e.pageY;
    const margem = 50;

    // Se a altura real do container não for maior que altura
    // apresentada na tela, cancela o scroll
    if (parseInt($container.outerHeight()) <= parseInt($container.height())) {
      return;
    }

    // Se a posição do mouse somada a margem definida
    // superar ou for o mesmo que o tamanho da tela,
    // definio o scroll pra baixo de 5 em 5 pixels
    if (mouseY + margem >= tamanhoTela) {
      scrollSize = 25;
      return;
    }

    // Se a posição do mouse menos a margem definida for menor que o
    // a distancia que temos do topo ao container, aplica o scroll
    // para cima reduzindo os pixels de 5 em 5
    if (mouseY - margem <= tamanhoTela - parseInt($container.height())) {
      scrollSize = -25;
      return;
    }

    // Valor default do scroll 0
    scrollSize = 0;
  });

  setInterval(() => {
    // Se a proprieadade do window que habilita o scroll
    // for false, retorna sem aplicar o scroll
    if (!window.enableScrollInvoices || scrollSize === 0) {
      return;
    }

    $container.scrollTop($container.scrollTop() + scrollSize);
  }, 50);
}

/**
 * Inicializa o filto de despesas de cards de despesas
 * para conciliar
 */
function initializeExpensesFilters() {
  const container = $(dataSelectorQueueExpenses);
  const filtersContainer = $('#form-filter-expenses');
  const filters = new Filters(route(routeFilterExpenses), filtersContainer);

  nifty.body.overlay({fixed: true});

  filters.before = function() {
    nifty.body.overlay('show');
  };

  filters.after = function(html) {
    if (html) {
      container.html(html);
      nifty.body.overlay('hide');

      const $cardExpenses             = $(`${dataSelectorQueueExpenses} ${dataSelectorCardExpense}`);
      const $buttonExpandFilters      = $(dataSelectorButtonExpandFilters);
      const $buttonsDisconcillate     = $(`${dataSelectorQueueExpenses} ${dataSelectorButtonDisconcillate}`);
      const $buttonShowExpenseDetails = $(`${dataSelectorQueueExpenses} ${dataSelectorButtonExpenseDetails}`);
      const isActiveFormFilters       = $buttonExpandFilters[0].closest('form').classList.contains('active');

      if ($cardExpenses.length) {
        initializeDraggableCardExpense($cardExpenses);
        $buttonsDisconcillate.on('click', handlerClickDisconcillate);
        $buttonShowExpenseDetails.on('click', handlerClickShowExpenseDetails);
      }

      setTimeout(() => {
        if (isActiveFormFilters) {
          $buttonExpandFilters.trigger('click');
        }
      }, 500);
      return;
    }

    nifty.body.overlay('hide');
  };
}

/**
 * Aplicando a movimentação dos cards que estavam sendo arrastados,
 * o que inclui colocar o card da fila no (gap), do (gap) na fila,
 * mover entre (gaps), substituir entre (gaps) também
 *
 * @param {Element} currentHolder
 * @param {Element} currentCardExpense
 */
function applyCardMovement(currentHolder, currentCardExpense) {
  // O holder que continha a depesa quando ela foi arrastada
  const oldHolder = currentCardExpense.parentElement;

  // Obtendo os atributos data dos holders envolvidos
  const oldData = getDroppableDataAttributes(oldHolder);
  const currentData = getDroppableDataAttributes(currentHolder);

  // Movendo o card da fila para a fila
  if (oldData.scope === 'queue' && currentData.scope === 'queue') {
    return;
  }

  // Se o card estava em um gap e agora está sendo movido
  // de volta para a fila
  if (oldData.hasExpense && currentData.scope === 'queue') {
    moveCardFromGapToQueue(oldHolder, currentHolder, currentCardExpense);
    return;
  }

  // Se o gap que o card está sendo colocado tiver uma despesa,
  // e o card arrastado estiver vindo da fila
  if (currentData.hasExpense && oldData.scope === 'queue') {
    toExchangeCardQueueWithGap(oldHolder, currentHolder, currentCardExpense);
    return;
  }

  // Se estiver sendo realizada uma troca de cards entre dois
  // gaps com despesas
  if (oldData.hasExpense && currentData.hasExpense) {
    toExchangeCardBetweenGaps(oldHolder, currentHolder, currentCardExpense);
    return;
  }

  // Se o card estava em um gap e estiver sendo movido
  // para outro gap vazio
  if (oldData.hasExpense && !currentData.hasExpense) {
    moveCardFromGapToOtherEmptyGap(oldHolder, currentHolder, currentCardExpense);
    return;
  }

  // Movendo o card da fila para um gap vazio
  moveCardFromQueueToEmptyGap(currentHolder, currentCardExpense);
}

/**
 * Trocando o card que está sendo arrastado da fila pelo que
 * estava no gap selecionado, inserindo o card arrastado no
 * gap selecionado, e colocando o card que estava no gap
 * selecionado de volta na fila
 *
 * @param {Element} oldHolder
 * @param {Element} currentHolder
 * @param {Element} currentCardExpense
 */
function toExchangeCardQueueWithGap(oldHolder, currentHolder, currentCardExpense) {
  const oldCardExpense = currentHolder.querySelector(dataSelectorCardExpense);
  const firstCardExpense = oldHolder.querySelector(dataSelectorCardExpense);

  // Validando o card que está sendo arrastado da fila para o gap
  if (!isValidConciliation(currentCardExpense, currentHolder)) {
    return;
  }

  let data = getDataToSendConciliation({}, currentHolder, null);
  data = getDataToSendConciliation(data, currentHolder, currentCardExpense);

  postRequest(data, routeConciliarItem)
    .done(function (response) {
      // Inserindo o card que estava no (gap) no topo da fila
      oldHolder.insertBefore(oldCardExpense, firstCardExpense);
      // Adicionando o card arrastado no (gap)
      currentHolder.append(currentCardExpense);

      // Exibindo as informações de diferença entre o card de despesa o item de fatura
      showDiffBetweenInvoiceItemAndExpenseCard(response.data, currentHolder, oldHolder);

      // Aplicando a alteração de status os itens envolvidos
      changeStatusInvoiceItem(response.data, currentHolder, oldHolder);

      //Abrindo modal de violações de política se existem
      if (!!response.data.quebraPolitica) {
        showItemsOutOfPolicy();
      }
    })
    .fail(function (error) {
      // Alterando o status dos itens que estavam sendo manipulados
      changeStatusInvoiceItem(error.responseJSON.data, currentHolder, oldHolder);
      // Exibindo toast com mensagem de erro padrão
      showError(error.responseJSON.message);
    });
}

/**
 * Trocando cards entre gaps, inserindo o card que está sendo
 * arrastado no gap selecionado e retirando o card que estava no
 * gap selecionado e colocando no gap em que o card arrastado estava
 *
 * @param {Element} oldHolder
 * @param {Element} currentHolder
 * @param {Element} currentCardExpense
 */
function toExchangeCardBetweenGaps(oldHolder, currentHolder, currentCardExpense) {
  const oldCardExpense = currentHolder.querySelector(dataSelectorCardExpense);

  // Validando o card que está sendo arrastado com o gap pretendido
  if (!isValidConciliation(currentCardExpense, currentHolder)) {
    return;
  }

  // Validando o card que ficará  no gap que o card arrastado estava
  if (!isValidConciliation(oldCardExpense, oldHolder)) {
    return;
  }

  let data = getDataToSendConciliation({}, oldHolder, oldCardExpense);
  data = getDataToSendConciliation(data, currentHolder, currentCardExpense);

  postRequest(data, routeConciliarItem)
    .done(function(response) {
      // Adicionando o card que está sendo arrasdo no (gap) escolhido
      currentHolder.append(currentCardExpense);

      // Adicionando o card que estava no (gap) escolhido no no gap que
      // o card arrastado estava no início da interação
      oldHolder.append(oldCardExpense);

      // Exibindo as informações de diferença entre o card de despesa o item de fatura
      showDiffBetweenInvoiceItemAndExpenseCard(response.data, currentHolder, oldHolder);

      // Aplicando a alteração de status os itens envolvidos
      changeStatusInvoiceItem(response.data, currentHolder, oldHolder);

      //Abrindo modal de violações de política se existem
      if (!!response.data.quebraPolitica) {
        showItemsOutOfPolicy();
      }
    })
    .fail(function(error) {
      // Alterando o status dos itens que estavam sendo manipulados
      changeStatusInvoiceItem(error.responseJSON.data, currentHolder, oldHolder);
      // Exibindo toast com mensagem de erro padrão
      showError(error.responseJSON.message);
    });
}

/**
 * Movendo o card que está sendo arrastado do gap para a fila,
 * retirando o card do gap e colocando no topo da fila
 *
 * @param {Element} oldHolder
 * @param {Element} currentHolder
 * @param {Element} currentCardExpense
 */
function moveCardFromGapToQueue(oldHolder, currentHolder, currentCardExpense) {
  const firstCardExpense = currentHolder.querySelector(dataSelectorCardExpense);
  const data = getDataToSendConciliation({}, oldHolder, null);

  postRequest(data, routeConciliarItem)
    .done(function(response) {
      // Inserindo o card no topo da fila de despesas a serem conciliadas
      currentHolder.insertBefore(currentCardExpense, firstCardExpense);

      // Exibindo novamente o element de gap de despesa que antes estava oculto
      // Setando no holder como false o atributo que indica se o holder contem uma despesa
      oldHolder.setAttribute(attributeHasExpense, false);

      // Exibindo as informações de diferença entre o card de despesa o item de fatura
      showDiffBetweenInvoiceItemAndExpenseCard(response.data, currentHolder, oldHolder);

      // Aplicando a alteração de status os itens envolvidos
      changeStatusInvoiceItem(response.data, currentHolder, oldHolder);

      //Abrindo modal de violações de política se existem
      if (!!response.data.quebraPolitica) {
        showItemsOutOfPolicy();
      }
    })
    .fail(function(error) {
      // Alterando o status dos itens que estavam sendo manipulados
      changeStatusInvoiceItem(error.responseJSON.data, currentHolder, oldHolder);
      // Exibindo toast com mensagem de erro padrão
      showError(error.responseJSON.message);
    });
}

/**
 * Movendo o card que está sendo arrastado de um gap para outro
 * gap vazio, removendo card do gap que estava, e adicionando
 * o gap selecionado
 *
 * @param {Element} oldHolder
 * @param {Element} currentHolder
 * @param {Element} currentCardExpense
 */
function moveCardFromGapToOtherEmptyGap(oldHolder, currentHolder, currentCardExpense) {
  let data = getDataToSendConciliation({}, currentHolder, currentCardExpense);
  data = getDataToSendConciliation(data, oldHolder, null);

  // Validando o card que está sendo arrastado com o gap pretendido
  if (!isValidConciliation(currentCardExpense, currentHolder)) {
    return;
  }

  postRequest(data, routeConciliarItem)
    .done(function(response) {
      // Ocultando o elemento de gap de despesa
      // Adicionando o card no holder que é droppable
      // Setando no holder o atributo que indica que ele possui uma despesa
      currentHolder.append(currentCardExpense);
      currentHolder.setAttribute(attributeHasExpense, true);

      // Exibindo novamente o element de gap de despesa que antes estava oculto
      // Setando no holder como false o atributo que indica se o holder contem uma despesa
      oldHolder.setAttribute(attributeHasExpense, false);

      // Exibindo as informações de diferença entre o card de despesa o item de fatura
      showDiffBetweenInvoiceItemAndExpenseCard(response.data, currentHolder, oldHolder);

      // Aplicando a alteração de status os itens envolvidos
      changeStatusInvoiceItem(response.data, currentHolder, oldHolder);

      //Abrindo modal de violações de política se existem
      if (!!response.data.quebraPolitica) {
        showItemsOutOfPolicy();
      }
    })
    .fail(function(error) {
      // Alterando o status dos itens que estavam sendo manipulados
      changeStatusInvoiceItem(error.responseJSON.data, currentHolder, oldHolder);
      // Exibindo toast com mensagem de erro padrão
      showError(error.responseJSON.message);
    })
}

/**
 * Movendo o card que esá sendo arrastado da fila para um gap
 * vazio, o card é removido da fila e adicionada no gap selecionado
 *
 * @param {Element} currentHolder
 * @param {Element} currentCardExpense
 */
function moveCardFromQueueToEmptyGap(currentHolder, currentCardExpense) {
  const data = getDataToSendConciliation({}, currentHolder, currentCardExpense);

  // Validando o card que está sendo arrastado com o gap pretendido
  if (!isValidConciliation(currentCardExpense, currentHolder)) {
    return;
  }

  postRequest(data, routeConciliarItem)
    .done(function(response) {
      // Ocultando o elemento de gap de despesa
      // Adicionando o card no holder que é droppable
      // Setando no holder como true o atributo que indica se o holder contem uma despesa
      currentHolder.append(currentCardExpense);
      currentHolder.setAttribute(attributeHasExpense, true);

      // Exibindo as informações de diferença entre o card de despesa o item de fatura
      showDiffBetweenInvoiceItemAndExpenseCard(response.data, currentHolder);
      // Aplicando a alteração de status os itens envolvidos
      changeStatusInvoiceItem(response.data, currentHolder);
      //Abrindo modal de violações de política se existem
      if (!!response.data.quebraPolitica) {
        showItemsOutOfPolicy();
      }
    })
    .fail(function(error) {
      // Alterando o status dos itens que estavam sendo manipulados
      changeStatusInvoiceItem(error.responseJSON.data, currentHolder);
      // Exibindo toast com mensagem de erro padrão
      showError(error.responseJSON.message);
    })
}

/**
 * Adicionar um card com o a despesa que foi criada
 * no topo da fila de cards de despesas
 *
 * @param {integer} idDespesaItem
 */
function createCardExpense(idDespesaItem) {
  const params =  {
    idDespesaItem
  };

  getRequest(params, routeGetCardExpense)
    .done((response) => {
      const queue = document.querySelector(dataSelectorQueueExpenses);
      queue.innerHTML = response + queue.innerHTML;

      // Pegando os elementos que usam eventos de dentro da fila
      const $cards = $(`${dataSelectorQueueExpenses} ${dataSelectorCardExpense}`);
      const $buttonsDisconcillate     = $(`${dataSelectorQueueExpenses} ${dataSelectorButtonDisconcillate}`);
      const $buttonShowExpenseDetails = $(`${dataSelectorQueueExpenses} ${dataSelectorButtonExpenseDetails}`);

      // Adicionano classe de interacao para despesa adicionada
      const newCard = document.querySelector(`[${dataAttributeCardExpenseId}="${idDespesaItem}"]`);
      newCard.classList.add('expense-card--added');
      setTimeout(() => {
        newCard.classList.remove('expense-card--added');
      }, 500);

      // Adicionando os eventos novamente
      initializeDraggableCardExpense($cards);
      $buttonsDisconcillate.on('click', handlerClickDisconcillate);
      $buttonShowExpenseDetails.on('click', handlerClickShowExpenseDetails);
    })
    .fail((error) => {
      location.reload();
    });
}

/**
 * Validando a conciliação que está sendo feita
 *
 * Se a despesa for de moeda diferente da moeda do item de fatura
 * ou se a despesa possuir um valor maior que o do item de fatura
 * a função exibe um toast com o erro de validação e retorna false
 * imediatamente, caso contrário se todas as validações forem
 * satisfeitas retorna true
 *
 *
 * @param {Element} cardExpense
 * @param {element} invoiceItem
 *
 * @return {boolean}
 */
function isValidConciliation(cardExpense, invoiceItem) {
  const expenseCurrency     = cardExpense.dataset.draggableExpenseCurrencyId;
  const invoiceItemCurrency = invoiceItem.dataset.droppableInvoiceItemCurrencyId;

  const ableConciliateExpenseLowerValue = document
    .querySelector('[data-able-conciliate-expense-lower-value]')
    .dataset
    .ableConciliateExpenseLowerValue;

  if (expenseCurrency !== invoiceItemCurrency) {
    GlobalAlerts.createAndShow({
      type: 'danger',
      title: Lang.get('js/src/functions/ConciliacoesDroppable.title_error_diff_currencies'),
      message: Lang.get('js/src/functions/ConciliacoesDroppable.message_error_diff_currencies'),
    });

    return false;
  }

  let expenseValue = cardExpense.dataset.draggableExpenseValue;
  expenseValue = ConversaoCambio.stringToFloat(expenseValue, ',');

  let invoiceItemTrasactionValue = invoiceItem.dataset.droppableInvoiceItemValorTransacao;
  invoiceItemTrasactionValue = ConversaoCambio.stringToFloat(invoiceItemTrasactionValue, '.');

  // Se a empresa não permite que a despesa tenha um valor menor
  // que o valor do item de fatura, aplicaamos essa validação
  // impedindo a conciliação nestes casos
  if (
    ableConciliateExpenseLowerValue === '0'
    && expenseValue < invoiceItemTrasactionValue
  ) {
    GlobalAlerts.createAndShow({
      type: 'danger',
      title: Lang.get('js/src/functions/ConciliacoesDroppable.expense_smaller_value'),
      message: Lang.get('js/src/functions/ConciliacoesDroppable.the_expense_has_lower_value_than_invoice_item'),
    });

    return false;
  }

  // Se o item de fatura for negativo (estorno)
  // o item de despesa deve ter o mesmo valor do item de estorno inclusive de sinal
  if (invoiceItemTrasactionValue < 0 && invoiceItemTrasactionValue !== expenseValue) {
    GlobalAlerts.createAndShow({
      type: 'danger',
      title: Lang.get('js/src/functions/ConciliacoesDroppable.reversal_conciliation'),
      message: Lang.get('js/src/functions/ConciliacoesDroppable.to_conciliate_a_reversal_the_expense_item_needs_the_same_amount_of_invoice_item_and_to_be_negative'),
    });

    return false;
  }

  // se oitem de fatura fpor positivo, o item de despesa não pode ser negativo
  if (invoiceItemTrasactionValue > 0 && expenseValue < 0) {
    GlobalAlerts.createAndShow({
      type: 'danger',
      title: Lang.get('js/src/functions/ConciliacoesDroppable.expense_item_negative'),
      message: Lang.get('js/src/functions/ConciliacoesDroppable.the_expense_item_negative_cant_be_conciliated_with_a_invoice_item_positive'),
    });

    return false;
  }

  if (expenseValue > invoiceItemTrasactionValue) {
    GlobalAlerts.createAndShow({
      type: 'danger',
      title: Lang.get('js/src/functions/ConciliacoesDroppable.title_error_expense_bigger_then_invoice_item'),
      message: Lang.get('js/src/functions/ConciliacoesDroppable.message_error_expense_bigger_then_invoice_item'),
    });

    return false;
  }

  return true;
}

/**
 * Manipula a div com o conteúdo de diferença entre o valor do item
 * de despesa e o valor do item de fatura, podendo não exibir o conteúdo,
 * exibir informação de ausência de despesa, ou o valor que que ainda
 * resta do item de fatura para ser conciliado
 *
 * @param {Object} data
 * @param  {...Elements} holders
 */
function showDiffBetweenInvoiceItemAndExpenseCard(data, ...holders) {
  holders.forEach((currentHolder) => {
    const dataHolder = getDroppableDataAttributes(currentHolder);
    const lancamentoMultimoedaContaCorrente = currentHolder.dataset.droppableLancamentoMultimoedaContaCorrente;

    if (dataHolder.scope === 'queue') {
      return;
    }

    const idFaturaItem      = currentHolder.dataset.droppableInvoiceItemId;
    const isoFaturaItem     = currentHolder.dataset.droppableInvoiceItemCurrencyIso;
    const diffInvoiceHolder = currentHolder.closest(classSelectorInvoiceItem).querySelector(dataSelectorInvoiceItemDiff);

    // Adicionando a mensagem de item de fatura sem despesa e removendo a classe de erro
    if (!dataHolder.hasExpense) {
      diffInvoiceHolder.innerHTML =  Lang.get('js/src/functions/ConciliacoesDroppable.there_isnt_expense_linked');
      diffInvoiceHolder.classList.remove(`${classInvoiceItemDifference}--diff`);
      return;
    }

    if (data[idFaturaItem].diferenca !== 0) {
      let diffInCurrencyExpense = Lang.get(
        'js/src/functions/ConciliacoesDroppable.diff_value',
        {
          isoMoeda: isoFaturaItem,
          valor: ConversaoCambio.formatExchangeRate(Math.abs(data[idFaturaItem].diferenca).toFixed(2))
        }
      );

      // Pegando os dados necessários para fazer o cálculo da diferença de valor entre
      // o item de fatura e o item de despesa na moeda padrão da empresa
      // apenas para empresas que não permitem lançamentos multimoedas no conta corrente
      if (lancamentoMultimoedaContaCorrente == 0) {
        const isoMoedaPadraoEmpresa = currentHolder.dataset.droppableCompanyDefaultCurrencyIso;
        const valorTransacao = ConversaoCambio.stringToFloat(currentHolder.dataset.droppableInvoiceItemValorTransacao, '.');
        const valorFaturado = ConversaoCambio.stringToFloat(currentHolder.dataset.droppableInvoiceItemValorFaturado, '.');
        const taxaCambio = ConversaoCambio.calculate(valorFaturado, valorTransacao, '/') ;
        const valorConvertido = ConversaoCambio.formatExchangeRate(
          Math.abs(data[idFaturaItem].diferenca * taxaCambio).toFixed(2)
        );

        diffInCurrencyExpense += `<br> [ ${isoMoedaPadraoEmpresa} ${valorConvertido} ]`;
      }

      // Adicionando a mensagem de diferença de valor e a classe de erro
      diffInvoiceHolder.classList.add(`${classInvoiceItemDifference}--diff`);
      diffInvoiceHolder.innerHTML = diffInCurrencyExpense;
      return;
    }

    // removendo a mensagem de diferença de valor e a classe de erro
    diffInvoiceHolder.classList.remove(`${classInvoiceItemDifference}--diff`);
    diffInvoiceHolder.innerHTML = '';
  });
}

/**
 * Manipula a div do item de fatura alterando o seu status e o
 * conteúdo de texto de dentro da badge que indica o status da
 * conciliação relacionado ao item de fatura
 *
 * @param {Object} data
 * @param  {...Element} holders
 */
function changeStatusInvoiceItem(data, ...holders) {
  if (!Object.entries(data).length) {
    return;
  }
  holders.forEach((currentHolder) => {
    const dataHolder = getDroppableDataAttributes(currentHolder);

    if (dataHolder.scope === 'queue') {
      return;
    }

    const idFaturaItem     = currentHolder.dataset.droppableInvoiceItemId;
    const statusItemFatura = data[idFaturaItem].statusItemFatura;

    const itemFaturaHolder = currentHolder.closest(classSelectorInvoiceItem);
    const itemFaturaBadge  = itemFaturaHolder.querySelector(classSelectorBadgeStatus);

    itemFaturaHolder.className = `${classInvoiceItem} ${classInvoiceItem}--${statusItemFatura}`;
    itemFaturaBadge.innerHTML = Lang.get(
      'js/src/functions/ConciliacoesDroppable.status_'
      + translateStatusConciliacao[statusItemFatura]
    );
  });
}

/**
 * Exibição de Erro padrão em forma de toast
 */
function showError(message = '') {
  GlobalAlerts.createAndShow({
    type: 'danger',
    title: Lang.get('js/src/functions/ConciliacoesDroppable.ops'),
    message: (message === '') ?
      Lang.get('js/src/functions/ConciliacoesDroppable.default_error')
      : message
  });
}

/**
 * Aplicação de classe CSS para personalizar o card que estiver
 * sendo movido e o seu original, já que estamos utilizando clones
 *
 * @param {Element} realCard
 * @param {Element} cloneCard
 */
function toogleClassesCardDragging(realCard, cloneCard) {
  cloneCard.classList.toggle(classCardExpenseDragging);
  realCard.classList.toggle(classCardExpenseOpacity);
}

/**
 * Obeter os atributos data, do elemento que é droppable dos cards
 * de despesas
 *
 * @param {Element} element
 * @return Object
 */
function getDroppableDataAttributes(element) {
  return {
    scope: element.dataset.droppableScope,
    hasExpense: (element.dataset.droppableHasExpense === 'true')
  };
}

/**
 * Obter o objeto usando o idFatura item como chave
 * e o id do item de despesa como valor para as requests
 *
 * @param {Object} data
 * @param {Element} elementHolder
 * @param {Element} cardExpense
 */
function getDataToSendConciliation(data, elementHolder, cardExpense = null) {
  const idFaturaItem  = elementHolder.dataset.droppableInvoiceItemId;
  data[idFaturaItem] = null;

  if (cardExpense === null) {
    return data;
  }

  data[idFaturaItem] = cardExpense.dataset.draggableExpenseId;
  return data;
}

/**
 * Enviar as requests com o método post para o servidor
 *
 * @param {Object} data
 * @param {string} routeName
 */
function postRequest(data, routeName, isFormData = false) {
  const propsRequest = {
    url: route(routeName),
    method: 'POST',
    data: data,
  };
  if (isFormData) {
    propsRequest.processData = false;
    propsRequest.contentType = false;
  }
  return $.ajax(propsRequest);
}

/**
 * Enviar request com o método GET para o servidor
 *
 * @param {string} routeName
 * @param {Object} params
 */
function getRequest(params, routeName) {
  return $.ajax({
    url: route(routeName, params),
    method: 'GET',
  });
}

/**
 * Produz modal de aviso de despesas importadas fora da política
 */
function showItemsOutOfPolicy() {
  bootbox.alert({
    title: Lang.get('js/src/functions/ConciliacoesDroppable.conciliation_policy'),
    message: Lang.get('js/src/functions/ConciliacoesDroppable.imported_expenses_out_of_policy'),
  });
}

module.exports = {
  init: ConciliacoesDroppable,
  url: /^\/conciliacoes\/\d/
};
